<div class="card tall">
    <h2 class="webapp-title-secondary">¿Vienes a España? No olvides tu seguro médico</h2>
    <h5 class="webapp-pre-title">Obligatorio para visado y NIE. Estudia y vive tranquilo desde el primer día.</h5>

    <ul class="list-unstyled text-left mb-4">
      <li class="mb-2"><i class="fas fa-check-circle text-success mr-2"></i> Cobertura médica desde tu llegada</li>
      <li class="mb-2"><i class="fas fa-check-circle text-success mr-2"></i> Acceso a hospitales públicos y privados</li>
      <li class="mb-2"><i class="fas fa-check-circle text-success mr-2"></i> Asistencia 24/7 en tu idioma</li>
      <li class="mb-2"><i class="fas fa-check-circle text-success mr-2"></i> Proceso fácil y 100% online</li>
    </ul>

    <button class="cta-button" (click)="goToForm()"><!--  -->
      Cotizar seguro ahora
    </button>

    <p>Te ayudamos paso a paso. Atención personalizada de nuestro equipo.</p>
</div>